// extracted by mini-css-extract-plugin
module.exports = {"anchors_float_left":"Navbar_anchors_float_left__2p1E-","language_anchor":"Navbar_language_anchor__2NwKD","help_anchor":"Navbar_help_anchor__22VW0"};